<template>
  <!-- @click="toggleProperty($event)" -->
  <section>
    <i
      ref="check"
      :class="{
        'far fa-square': !property.fixed,
        'fas fa-check': property.fixed,
      }"
    />
    <input
      ref="inputNum"
      v-if="property.type == 'numeric'"
      type="tel"
      v-model="num"
      @input="keyDownHandler"
    />
    {{
      property.fixed
        ? property.name
        : property.name + ` (${property.price} ${currency})`
    }}
  </section>
</template>

<script>
export default {
  name: "ProjectProperty",
  props: ["property"],
  data() {
    return {
      num: 1,
    };
  },
  methods: {
    isChecked() {
      return this.$refs["check"]?.className?.includes("fas fa-check");
    },
    removeCheck() {
      this.$refs["check"].className = this.$refs["check"].className.replace(
        "fas fa-check",
        "far fa-square"
      );
    },
    addCheck() {
      this.$refs["check"].className = this.$refs["check"].className.replace(
        "far fa-square",
        "fas fa-check"
      );
    },
    toggleProperty(e) {
      if (!this.property.fixed && e?.target?.nodeName != "INPUT") {
        const element = this.$refs["check"];
        if (element) {
          if (this.isChecked()) {
            this.removeCheck();
          } else {
            this.addCheck();
          }
        }
      }
    },
    keyUpHandler() {
      if (this.num < 0 || isNaN(this.num)) this.num = 1;
    },
    keyDownHandler(e) {
      // const element = this.$refs["check"];
      // if(!this.isChecked()){
      //   this.addCheck(element)
      // }
      if ("0123456789".indexOf(e.data) == -1) {
        this.num = this.num.replace(e.data, "");
        e.preventDefault();
      }
    },
    getPrice() {
      return isNaN(this.property.price * this.num)
        ? 0
        : this.property.price * this.num;
    },
    getNum() {
      return this.num;
    },
  },
  computed: {
    currency() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].currency;
    },
  },
};
</script>
